/**
 * @generated SignedSource<<b67b4fcac39c6719b8228cdc1c1484d7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespFeaturedItemsGridLazy_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespFeaturedItemsGrid_user">;
  readonly " $fragmentType": "PdpRespFeaturedItemsGridLazy_user";
};
export type PdpRespFeaturedItemsGridLazy_user$key = {
  readonly " $data"?: PdpRespFeaturedItemsGridLazy_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespFeaturedItemsGridLazy_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespFeaturedItemsGridLazy_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespFeaturedItemsGrid_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "66d887f19059ac1fee9f21c795ac0698";

export default node;
